import { shipTypeData } from "src/mock/selectOptions";

const validShipTypeValues = new Set(shipTypeData.map(item => item.value));

/** Maps Yacht Setup vtype ("VT3") to a WDR Type of Ship value ("3"). */
export const vtypeToShipType = (vtype?: string | null): string | undefined => {
  if (!vtype) return undefined;

  const match = /^VT(\d+)$/.exec(vtype);
  if (!match) return undefined;

  const shipType = match[1];
  return validShipTypeValues.has(shipType) ? shipType : undefined;
};

const OTHER_SHIP_TYPE = "8";

/** Decides the value to fill the "specify" target when Type of Ship is Other. */
export const getOtherFillValue = (
  key?: string,
  currentTargetValue?: string,
  vtypeother?: string,
): string | undefined => {
  if (key !== OTHER_SHIP_TYPE) return undefined;
  if (currentTargetValue) return undefined;
  if (!vtypeother) return undefined;

  return vtypeother;
};
